import { useContext, useEffect, useState } from 'react';

import { Navigate, Outlet, useLocation } from 'react-router-dom';

// context
import { Context } from '../context/Context';
import { getStoredUser, clearUserSession } from '../helpers/auth/storage';
import { checkTokenRequest } from '../helpers/auth/checkToken';

// constants
import constants from '../constants/Constants';

const ProtectedRoute = ({ children }) => {
  const { state, setState, setResponse } = useContext(Context);
  const lang = state.lang;
  const [allowed, setAllowed] = useState(() => !!getStoredUser().token);
  const location = useLocation();

  useEffect(() => {
    const token = getStoredUser().token;
    if (!token) {
      setAllowed(false);
      return;
    }
    setAllowed(true);
    if (state.noToken) return;
    checkToken();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {}, [state.login]);

  const checkToken = () => {
    setState((prev) => ({
      ...prev,
      checkingToken: true,
    }));
    if (getStoredUser().token) {
      try {
        const token = getStoredUser().token;
        if (token) {
          setState((prev) => ({
            ...prev,
            loading: true,
          }));
          checkTokenRequest(token)
            .then((data) => {
              if (data?.status === 200 && data?.valid) {
                setAllowed(true);
                const storedUser = getStoredUser();

                setState((prev) => ({
                  ...prev,
                  login: true,
                  loading: false,
                  user: {
                    id: storedUser.id,
                    username: storedUser.username,
                    role: storedUser.role,
                    token: storedUser.token,
                    scopes: storedUser.scopes,
                  },
                }));
                return true;
              }

              clearUserSession();
              setState((prev) => ({
                ...prev,
                checkingToken: false,
                noToken: true,
                loading: false,
                login: false,
              }));
              return false;
            })
            .catch((error) => {
              let message = 'Error al Iniciar Sesión';
              if (error.response?.data) {
                if (error.response.data.valid === false) {
                  clearUserSession();
                  if (lang === 'ES') {
                    message = 'Token no válido';
                  } else {
                    message = 'Invalid token';
                  }
                } else {
                  const msjErr = error.response.data.error;
                  for (const key in msjErr) {
                    if (key === lang) {
                      message = msjErr[key];
                    }
                  }
                }
              }
              const resp = {
                title: 'Error',
                message,
                typeAlert: constants.ALERT_ERROR,
                status: true,
              };
              setResponse(resp);
              setState((prev) => ({
                ...prev,
                loading: false,
                login: false,
              }));
              setAllowed(false);
            });
        } else {
          clearUserSession();
          setState((prev) => ({
            ...prev,
            checkingToken: false,
            noToken: true,
            login: false,
            loading: false,
          }));
          setAllowed(false);
          return false;
        }
      } catch (error) {
        let message = 'Error al Iniciar Sesión';
        if (error.response?.data) {
          const msjErr = error.response.data.error;
          for (const key in msjErr) {
            if (key === lang) {
              message = msjErr[key];
            }
          }
        }
        const resp = {
          title: 'Error',
          message,
          typeAlert: constants.ALERT_ERROR,
          status: true,
        };
        setState((prev) => ({
          ...prev,
          loading: false,
          responses: resp,
        }));
      }
    } else {
      setState((prev) => ({
        ...prev,
        checkingToken: false,
        loading: false,
      }));
      return false;
    }
  };

  if (!allowed) {
    return <Navigate to='/login' replace state={{ from: location }} />;
  }

  return children ? children : <Outlet />;
};

export default ProtectedRoute;
